const Inicio = () => {
    return (
        <main className="main">

            {/* Inicio */}
            <section id="hotel-hero" className="hotel-hero section dark-background">
                <div className="hero-content">
                    <div className="hero-background">
                        <img src="/assets/images/bg.jpg" alt="" />
                        <div className="hero-overlay"></div>
                    </div>

                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="hero-text text-center" data-aos="fade-up" data-aos-delay="100">
                                    <h1>Bela María, tu mejor versión</h1>
                                    <p className="hero-subtitle">Un espacio exclusivo que une belleza, salud y bienestar. Porque mereces vivir tu mejor versión, todos los días.</p>
                                </div>

                                <div className="hero-actions" data-aos="fade-up" data-aos-delay="400">
                                    <a href="/register" className="btn btn-light btn-lg">
                                        <i className="bi bi-person"></i>
                                        Crear mi cuenta
                                    </a>
                                    <a href="#contact" className="btn btn-outline-light btn-lg">
                                        <i className="bi bi-house-door"></i>
                                        Conócenos
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Nosotros */}
            <section id="about-home" className="about-home section">
                <div className="container" data-aos="fade-up" data-aos-delay="100">
                    <div className="row align-items-center">
                        <div className="col-lg-5" data-aos="fade-up" data-aos-delay="200">
                            <div className="about-images">
                                <div className="image-stack">
                                    <div className="image-main">
                                        <img src="assets/images/2.jpg" alt="Heritage Hotel Exterior" className="img-fluid" />
                                    </div>
                                    <div className="image-overlay">
                                        <img src="assets/images/1.jpg" alt="Elegant Room Interior" className="img-fluid" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-7" data-aos="fade-up" data-aos-delay="300">
                            <div className="about-content">
                                <div className="section-header">
                                    <span className="subtitle">Bienestar &amp; Excelencia</span>
                                    <h2>El comienzo</h2>
                                </div>

                                <p>Llegó el lugar donde podrás crear la mejor versión de ti. <b>BelaMaria Spa</b> ofrece tecnología y tratamientos especializados para consentirte de pies a cabeza. Cuenta con habitaciones posquirúrgicas, tina fría, alberca templada, yoga, meditación, depilación definitiva con láser diodo, power shape, limpiezas y tratamientos faciales, masajes, y paquetes para contornear la cintura, todo pensado para tu bienestar.</p>

                                <p>Disfruta también de la terraza exclusiva de <b>Máximo Coffee & Brunch</b>, con menú gourmet y cócteles refrescantes a base de café. La Gobernadora Tere Jiménez, clientes, familiares y amigos asistieron al evento de gala, corte de listón, bendición y recorrido de instalaciones. <b>BelaMaría Spa</b> y <b>Máximo Coffee & Brunch</b>: el lugar ideal para vivir experiencias de belleza, relajación, salud y sabor.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Instalaciones */}
            <section id="amenities-cards" className="amenities-cards section light-background">
                <div className="container section-title" data-aos="fade-up">
                    <h2>Instalaciones</h2>
                    <p>Conoce los beneficios y amenidades que Bela Maria ofrece para ti</p>
                </div>

                <div className="container" data-aos="fade-up" data-aos-delay="100">
                    <div className="row gy-5">
                        <div className="col-lg-6" data-aos="zoom-in" data-aos-delay="200">
                            <div className="amenity-card">
                                <div className="card-header">
                                    <div className="amenity-icon">
                                    <i className="bi bi-sun"></i>
                                    </div>
                                    <h4>Terraza</h4>
                                </div>
                                <div className="amenity-content">
                                    <p>Un espacio al aire libre diseñado para la relajación y la convivencia, donde el descanso y la armonía se integran en un ambiente tranquilo y exclusivo.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6" data-aos="zoom-in" data-aos-delay="300">
                            <div className="amenity-card">
                                <div className="card-header">
                                    <div className="amenity-icon">
                                    <i className="bi bi-water"></i>
                                    </div>
                                    <h4>Alberca</h4>
                                </div>
                                <div className="amenity-content">
                                    <p>Nuestra alberca es un área pensada para el bienestar físico y mental, ideal para complementar los tratamientos y brindar momentos de relajación en un entorno cuidado y confortable.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6" data-aos="zoom-in" data-aos-delay="400">
                            <div className="amenity-card">
                                <div className="card-header">
                                    <div className="amenity-icon">
                                    <i className="bi bi-snow"></i>
                                    </div>
                                    <h4>Tina helada</h4>
                                </div>
                                <div className="amenity-content">
                                    <p>La tina ofrece una experiencia de descanso profundo, diseñada para ayudar a liberar tensiones y favorecer la recuperación en un espacio íntimo y sereno.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6" data-aos="zoom-in" data-aos-delay="500">
                            <div className="amenity-card">
                                <div className="card-header">
                                    <div className="amenity-icon">
                                    <i className="bi bi-droplet-half"></i>
                                    </div>
                                    <h4>Regaderas</h4>
                                </div>
                                <div className="amenity-content">
                                    <p>Áreas de regaderas equipadas para brindar comodidad y privacidad, ideales para acompañar cada experiencia de bienestar antes o después de los servicios.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6" data-aos="zoom-in" data-aos-delay="200">
                            <div className="amenity-card">
                                <div className="card-header">
                                    <div className="amenity-icon">
                                    <i className="bi bi-person-hearts"></i>
                                    </div>
                                    <h4>Niñera</h4>
                                </div>
                                <div className="amenity-content">
                                    <p>Un servicio pensado para brindar tranquilidad y confianza, permitiendo que disfrutes de tu experiencia en Bela María mientras tus pequeños reciben atención en un entorno seguro.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="amenities-cta text-center mt-5" data-aos="fade-up" data-aos-delay="600">
                        <div className="cta-content">
                            <h5>Un espacio diseñado para tu bienestar</h5>
                            <p className="mb-4">Cada área de Bela María ha sido pensada para ofrecer comodidad, privacidad y armonía, creando el entorno ideal para el descanso, el autocuidado y la experiencia integral.</p>
                            <a href="#contact" className="btn-explore">Conocer instalaciones</a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Servicios */}
            <section id="amenities" className="amenities section">

                <div className="container section-title" data-aos="fade-up">
                    <h2>Servicios</h2>
                    <p>Descubre los distintos servicios que Bela María ofrece en sus instalaciones</p>
                </div>

                <div className="container" data-aos="fade-up" data-aos-delay="100">

                    <div className="row gy-4">

                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                            <div className="amenity-card">
                            <div className="amenity-image">
                                <img src="assets/images/maquillaje.png" alt="Maquillaje y peinado" className="img-fluid" loading="lazy" />
                            </div>
                            <div className="amenity-content">
                                <h3>Maquillaje y peinado</h3>
                                <p>Servicios enfocados en resaltar tu belleza natural para ocasiones especiales o cuidado personal, realizados en un ambiente cómodo y profesional que prioriza la atención personalizada y el detalle.</p>
                            </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                            <div className="amenity-card">
                            <div className="amenity-image">
                                <img src="assets/images/manicura.png" alt="Manicura y pedicura" className="img-fluid" loading="lazy" />
                            </div>
                            <div className="amenity-content">
                                <h3>Manicura y pedicura</h3>
                                <p>Tratamientos diseñados para el cuidado y la estética de manos y pies, combinando técnica, higiene y bienestar en un espacio pensado para la relajación y el autocuidado.</p>
                            </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
                            <div className="amenity-card">
                            <div className="amenity-image">
                                <img src="assets/images/medicina.png" alt="Medicina estética" className="img-fluid" loading="lazy" />
                            </div>
                            <div className="amenity-content">
                                <h3>Medicina estética</h3>
                                <p>Procedimientos orientados al cuidado estético y al bienestar integral, realizados por especialistas certificados, en un entorno que promueve la confianza, la seguridad y la atención personalizada.</p>
                            </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                            <div className="amenity-card">
                            <div className="amenity-image">
                                <img src="assets/images/aparatologia.png" alt="Aparatología" className="img-fluid" loading="lazy" />
                            </div>
                            <div className="amenity-content">
                                <h3>Aparatología</h3>
                                <p>Tratamientos que incorporan tecnología especializada como complemento al cuidado estético y corporal, enfocados en brindar experiencias personalizadas dentro de un ambiente profesional y controlado.</p>
                            </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                            <div className="amenity-card">
                            <div className="amenity-image">
                                <img src="assets/images/masajes.png" alt="Masajes y terapias" className="img-fluid" loading="lazy" />
                            </div>
                            <div className="amenity-content">
                                <h3>Masajes y terapias</h3>
                                <p>Experiencias pensadas para favorecer la relajación, aliviar tensiones y promover el equilibrio físico y mental, adaptadas a las necesidades de cada persona en un entorno tranquilo y armonioso.</p>
                            </div>
                            </div>
                        </div>

                    </div>

                    <div className="row mt-5" data-aos="fade-up" data-aos-delay="300">
                        <div className="col-12">
                            <div className="seasonal-banner">
                                <div className="banner-bg">
                                    <img src="assets/images/3.jpg" alt="Winter Promotion" className="img-fluid" />
                                </div>
                                <div className="banner-content">
                                    <div className="banner-text">
                                        <h3>Cada servicio forma parte de una experiencia integral</h3>
                                        <p>En Bela María, los servicios no se viven de forma aislada. Cada experiencia está diseñada para acompañarte en tu camino hacia el bienestar, la belleza y el equilibrio personal.</p>
                                    </div>
                                    <div className="banner-cta">
                                        <a href="/register" className="btn btn-light">Crear mi cuenta</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </section>

            {/* Contacto */}
            <section id="contact" className="contact section light-background">

                <div className="container section-title" data-aos="fade-up">
                    <h2>Contacto</h2>
                    <p>Nuestra ubicación, horarios de atención y datos de contacto</p>
                </div>

                <div className="container" data-aos="fade-up" data-aos-delay="100">

                    <div className="row gy-4 mb-5">
                        <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
                            <div className="contact-info-box">
                            <div className="icon-box">
                                <i className="bi bi-geo-alt"></i>
                            </div>
                            <div className="info-content">
                                <h4>Ubicación</h4>
                                <p>Montes Himalaya 406, Los Bosques, 20120 Aguascalientes, Ags.</p>
                            </div>
                            </div>
                        </div>

                        <div className="col-lg-4" data-aos="fade-up" data-aos-delay="200">
                            <div className="contact-info-box">
                            <div className="icon-box">
                                <i className="bi bi-envelope"></i>
                            </div>
                            <div className="info-content">
                                <h4>Teléfonos</h4>
                                <p><b>Bela María:</b> 449 580 0092</p>
                                <p><b>Maximo Coffe:</b> 449 545 1061</p>
                            </div>
                            </div>
                        </div>

                        <div className="col-lg-4" data-aos="fade-up" data-aos-delay="300">
                            <div className="contact-info-box">
                            <div className="icon-box">
                                <i className="bi bi-headset"></i>
                            </div>
                            <div className="info-content">
                                <h4>Horarios</h4>
                                <p><b>Lun - Vie:</b> 9 AM - 8 PM</p>
                                <p><b>Sabados:</b> 10 AM - 4 PM</p>
                            </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="map-section" data-aos="fade-up" data-aos-delay="200">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3701.3092137708463!2d-102.3078594!3d21.9226611!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429ef4c42fcc3f5%3A0x8825ecd76727ac7c!2sBelaMaria!5e0!3m2!1ses!2smx!4v1768193313251!5m2!1ses!2smx" width="100%" height="500" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div>

            </section>

        </main>
    )
}

export default Inicio;